import { PREDICTION_TYPES } from '../../core/constants/actionTypes';


export const cntrlGetSmartPick = payload => {
  return {
    type: PREDICTION_TYPES.GET_SMART_PICK.CNTRL,
    payload,
  }
};
